<template>
    <div
        v-cloak
        class="row"
    >
        <div class="col-xs-12">
            <div class="box box-primary">
                <div class="box-header with-border">
                    <h3 class="box-title">Accounts Table</h3>
                    <div class="box-tools pull-right">
                        <button
                            class="btn btn-box-tool"
                            title="Collapse"
                            type="button"
                            @click="toggleCollapse"
                        >
                            <i
                                :class="changeIcon(collapse)"
                                class="fa"
                            ></i>
                        </button>
                    </div>
                </div>
                <vue-slide-up-down
                    :active="collapse"
                    :duration="durationCollapse"
                >
                    <SDAccountsTable
                        v-bind="$attrs"
                        :route="routes"
                    />
                </vue-slide-up-down>
            </div>
        </div>
    </div>
</template>

<script>
import SDAccountsTable from './template/SDAccountsTable';

export default {
    components: {
        SDAccountsTable,
    },
    props: {
        isLive: Boolean,
    },
    data: function () {
        return {
            routes: {
                show: this.$route.path + '/:id:',
                edit: this.$route.path + '/:id:/edit',
                activate: '/sd-accounts/:id:/activeVue/1',
                deactivate: '/sd-accounts/:id:/activeVue/0',
            },
            collapse: true,
            durationCollapse: 700,
        };
    },
    methods: {
        changeIcon: function (value) {
            return value ? 'fa-minus' : 'fa-plus';
        },
        toggleCollapse() {
            this.collapse = !this.collapse;
        },
    },
};
</script>
